(() => {
  const selector = 'a[href="#shopifyReshowConsentBanner"]';
  let opening;
  async function showPreferences() {
    if (opening) return opening;
    opening = (async () => {
      for (let attempt = 0; !window.privacyBanner?.showPreferences && attempt < 40; attempt++) {
        await new Promise(resolve => setTimeout(resolve, 250));
      }
      const banner = window.privacyBanner;
      if (!banner || typeof banner.showPreferences !== 'function') {
        throw new Error('Cookie preferences are temporarily unavailable.');
      }
      let timer;
      try {
        await Promise.race([banner.showPreferences(), new Promise((_, reject) => {
          timer = setTimeout(() => reject(new Error('Cookie preferences timed out.')), 20000);
        })]);
      } finally { clearTimeout(timer); }
    })();
    try { await opening; } finally { opening = undefined; }
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.(selector);
    if (!link) return;
    event.preventDefault();
    showPreferences().catch(() => {
      let notice = document.getElementById('bf-cookie-status');
      if (!notice) {
        notice = document.createElement('p');
        notice.id = 'bf-cookie-status';
        notice.setAttribute('role', 'status');
        link.parentNode.appendChild(notice);
      }
      notice.textContent = 'Il pannello cookie non è disponibile in questo momento. Ricarica la pagina e riprova.';
    });
  });
})();
